import SongsModule from "./songs";
import PlaylistsModule from "./playlists";
import PlaylistItemModule from "./playlist";
import ImportModule from "./import";

export default {
  SongsModule,
  PlaylistsModule,
  PlaylistItemModule,
  ImportModule,
};
